import { useEffect } from 'react';
import LandingPage from './index';

/**
 * Wrapper pour la landing page qui gère les styles overflow
 * Cette solution garantit que l'effet sticky fonctionne SANS casser l'app
 */
export function LandingWrapper() {
  useEffect(() => {
    // Sauvegarder les styles originaux
    const originalHtmlOverflow = document.documentElement.style.overflow;
    const originalBodyOverflow = document.body.style.overflow;
    
    // Appliquer overflow: visible pour permettre le sticky
    // L'overflow-x sera géré par .landing-page elle-même
    document.documentElement.style.overflow = 'visible';
    document.body.style.overflow = 'visible';
    
    // Ajouter une classe pour cibler spécifiquement la landing
    document.body.classList.add('landing-active');
    
    // Cleanup : restaurer les styles originaux quand on quitte la page
    return () => {
      document.documentElement.style.overflow = originalHtmlOverflow;
      document.body.style.overflow = originalBodyOverflow;
      document.body.classList.remove('landing-active');
    };
  }, []);
  
  return <LandingPage />;
}
